import { SyncDisabled } from "@mui/icons-material";
import { Typography, Button, Box, TextField } from "@mui/material";
import { Modal } from "components/common/Modal";
import { useState } from "react";

interface ClientDeactivateAssetRetrievalModalProps {
  open: boolean;
  enabled: boolean;
  reason: string;
  setOpen: (open: boolean) => void;
  updateStatus: (assetRetrievalSuspended: boolean, assetRetrievalSuspendedReason: string) => Promise<void>;
}

export default function ClientDeactivateAssetRetrievalModal({
  open,
  enabled,
  reason,
  setOpen,
  updateStatus,
}: ClientDeactivateAssetRetrievalModalProps) {
  const [deactivationReason, setDeactivationReason] = useState<string>(reason);
  const [isValid, setValid] = useState<boolean | null>();
  const validate: boolean = deactivationReason.length > 0;
  function onClose() {
    setDeactivationReason("");
    setValid(null);
  }

  return (
    <Modal open={open} setOpen={setOpen} width={"683px"} onClose={() => onClose()}>
      <Box mt={4}>
        <Box sx={{ textAlign: "center" }}>
          <SyncDisabled color="primary" sx={{ fontSize: "60px" }} />
          <Typography mt={1} variant="h5" component="h2" fontWeight={800} fontSize={"24px"}>
            Deactivate Asset Retrieval
          </Typography>
          <Typography mt={1} color="text.secondary" fontSize={"16px"} gutterBottom>
            {enabled
              ? "Are you sure you want to proceed with enabling asset retrieval for this client? They will be able to place new orders."
              : "Are you sure you want to proceed with deactivating asset retrieval for this client? They will no longer be able to place new orders."}
          </Typography>
          <TextField
            autoFocus
            error={isValid == false}
            helperText={
              isValid
                ? null
                : enabled
                  ? "Enter a reason for enabling asset retrieval."
                  : "Enter a reason for disabling asset retrieval."
            }
            placeholder={
              enabled
                ? "Please specify a reason for enabling asset retrieval..."
                : "Please specify a reason for disabling asset retrieval..."
            }
            onBlur={() => setValid(validate)}
            value={deactivationReason}
            onChange={(e) => {
              setDeactivationReason(e.target.value);
            }}
          />
          <Box mt={4} sx={{ display: "flex", gap: 1, alignItems: "center", justifyContent: "center" }}>
            {enabled ? "true" : "false"}
            <Button
              disabled={validate == false}
              variant="contained"
              onClick={() => updateStatus(!enabled, deactivationReason)}
            >
              {enabled ? "Yes, activate asset retrieval" : "Yes, deactivate asset retrieval"}
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setOpen(false);
                onClose();
              }}
            >
              No, go back
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
